import { stagger } from '@/lib/motion';
import { Tag } from '@/components/badges';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import type { UsagePlan } from '@/api/schemasUsage';
import { planLines, policyText, sourceText } from './usageModel';

/** The plan Hangar's administrators set for this organization: its limits and what happens at the limit (only rendered once one is set). */
export function PlanCard({ plan }: { plan: UsagePlan }) {
  return (
    <Card data-testid="usage-plan" className="enter" style={stagger(1)}>
      <CardHeader>
        <CardTitle className="flex flex-wrap items-center gap-2">
          Plan
          <Tag className="text-foreground">{plan.name}</Tag>
        </CardTitle>
        <CardDescription>
          {sourceText(plan)}. {policyText(plan)}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <dl className="grid grid-cols-2 gap-x-8 gap-y-3 lg:grid-cols-4">
          {planLines(plan).map((line) => (
            <div key={line.label} className="flex min-w-0 flex-col gap-0.5">
              <dt className="text-[13px] text-muted-foreground">{line.label}</dt>
              <dd className="tabular font-mono text-[15px] font-semibold text-foreground">{line.value}</dd>
            </div>
          ))}
        </dl>
      </CardContent>
    </Card>
  );
}
